<template>
    <div>
        <el-dialog
                title="消券使用途径备注"
                width="40%"
                :visible.sync="isShowDialog"
                @close="closeDialog">
            <el-form ref="eliminateCoupon" label-width='100px'>
                <el-input v-model="eliminateRemark"
                          type="textarea"
                          placeholder="选择多个券进行消券时备注会是同一备注(使用途径)"
                          maxlength="50"
                          show-word-limit></el-input>
            </el-form>
            <div class='dialog-footer'>
                <el-button @click='isShowDialog = false'>取 消</el-button>
                <el-button @click='eliminateCoupon'>确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

  import { collateCoupon } from '@/api/coupon/coupon'
  export default {
    name: 'editCoupon',
    data() {
      return {
        couponUses: [],
        eliminateRemark: '',
        isShowDialog: false
      }
    },
    created() {
    },
    methods: {
      showDialog(data) {
        this.couponUses = data
        this.isShowDialog = true
      },
      // 关闭页面
      closeDialog() {
        this.isShowDialog = false
        this.$refs['eliminateCoupon'].resetFields()
      },
      // 消券
      eliminateCoupon() {
        let data = {
          ids: this.couponUses.map(res => res.id),
          eliminateRemark: this.eliminateRemark
        }
        collateCoupon(data).then(res => {
          if (res.code === '0') {
            // 消券成功后刷新页面以及关闭弹窗
            this.$emit('refresh-list')
            this.closeDialog()
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
</style>